module.exports = __webpack_public_path__ + "img/cloud3_3.57b3a4d5.png";